module.exports = __webpack_public_path__ + "img/indicator.84c4dc51.png";